module.exports = __webpack_public_path__ + "media/kda-popstars-ft-madison-beer-gi-dle-jaira-burns-music-video-league-of-legends.29d2b936.mp3";